import { defineComponent } from "vue";

export default defineComponent({
  template: `
      <div
          class="modal-view"
          :class="{
            hidden: this.isVisible === false,
          }"
          @click="this.$emit('hide')"
      >
      <div class="modal-view-dialog" @click="onContentClick">
        <div class="modal-view-content">
          <div v-if="$slots.header" class="modal-view-header">
            <slot name="header" />
          </div>
          <div class="modal-view-actions">
            <button class="modal-view-close" @click="this.$emit('hide')"></button>
          </div>
          <div
              :class="{
            'modal-view-body': true,
            'modal-view-body-padding': this.contentPadding,
          }"
          >
            <slot></slot>
          </div>
          <div v-if="$slots.footer" class="modal-view-footer">
            <slot name="footer" />
          </div>
        </div>
      </div>
      </div>
    `,
  name: "ModalView",
  emits: ["hide"],
  props: {
    isVisible: {
      type: Boolean,
      default: true,
    },
    contentPadding: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    onContentClick(e: Event) {
      e.stopPropagation();
    },
  },
});
